import { render, staticRenderFns } from "./OnboardCompleteConfirm.vue?vue&type=template&id=04f292cf"
import script from "./OnboardCompleteConfirm.vue?vue&type=script&lang=ts"
export * from "./OnboardCompleteConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports